module.exports = __webpack_public_path__ + "img/emprendec.745584e3.png";